var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.418,
    height: 33.418,
    viewBox: "0 0 33.418 33.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(0 -1.291)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_583",
    "data-name": "Ellipse 583",
    cx: 16.709,
    cy: 16.709,
    rx: 16.709,
    ry: 16.709,
    transform: "translate(0 1.291)",
    fill: "#ffff01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59191",
    "data-name": "Path 59191",
    d: "M8.544-10.3h5.078v2.26H8.544v5.129H6.284V-8.036H1.219V-10.3H6.284v-5.18h2.26Z",
    transform: "translate(9.209 28)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPlus);
export default __webpack_public_path__ + "static/media/new_plus.f90804af8f81e89ab5034bcc7a5fcb0d.svg";
export { ForwardRef as ReactComponent };